
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 5a2 2 0 012-2h20a2 2 0 012 2v14a2 2 0 01-2 2H2a2 2 0 01-2-2V5z","fill":"url(#paint0_linear_8935_116276)"}}),_c('path',{attrs:{"opacity":".5","d":"M6 8h3","stroke":"#fff","stroke-width":"4","stroke-linecap":"round"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_8935_116276","x1":"0","y1":"3","x2":"25.657","y2":"18.204","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#05A5DC"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#4BB45F"}})])])])
          )
        }
      }
    